module.exports = __webpack_public_path__ + "static/media/setmana_santa.cdae0c3e.jpg";